import { createFileRoute } from "@tanstack/react-router";
import { FollowingPage } from "@/features/follows/FollowingPage";

export const Route = createFileRoute("/_app/follows")({
  component: FollowingPage,
});
